import React, { Fragment } from 'react'

export const About = () => {
    return (
        <Fragment>
            <h1>
            About this application
            </h1>
            <p>App to search github users</p>
        </Fragment>
    )
}
